import { Aircraft } from './aircraft';
import { PriceBreakdown } from '../../../../shared/models';

export class SmartJetDOption {
  aircraft: Aircraft;
  priceBreakdown: PriceBreakdown;

  getAircraft(): Aircraft {
    return this.aircraft;
  }

  setAircraft(aircraft: Aircraft): SmartJetDOption {
    this.aircraft = aircraft;

    return this;
  }

  getPriceBreakdown(): PriceBreakdown {
    return this.priceBreakdown;
  }

  setPriceBreakdown(priceBreakdown: PriceBreakdown): SmartJetDOption {
    this.priceBreakdown = priceBreakdown;
    
    return this;
  }
}
